import { type Route } from '#app/routes/mocra+/_sections+/+types/607.ts'
import { SECTIONS } from '#app/routes/mocra+/_sections+/section-data.ts'
import { SectionDetail } from '#app/routes/mocra+/_sections+/section-detail.tsx'

export const meta: Route.MetaFunction = () => [
	{ title: 'MoCRA — §607 Facility Registration & Product Listing' },
]

export default function Section607() {
	return <SectionDetail section={SECTIONS['607']} />
}
